<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="报表选择">
                <el-select v-model="queryForm.reportId" style="width: 175px" placeholder="请选择数据类型">
                    <el-option
                        v-for="(item,index) in reportIdList"
                        :key="index"
                        :label="item.reportName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="查询时间">
                <el-date-picker
                    v-model="queryForm.time"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getReportDailyList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <span class="title" v-if='reportName'>{{reportName}}</span>
                    <el-button
                        type='primary'
                        size='small'
                        style="margin-left: 20px"
                        @click='openIsShow'
                    >报表自定义管理
                    </el-button>
                </div>
                <div class="icon-group">
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshReportDailyList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!--数据列表-->
            <el-table
                :data="dataList"
                row-key="id"
                height="100%"
                border
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size="small"
            >
                <el-table-column
                    v-if="dataHeadList.length > 0"
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    v-for="(item,index) in dataHeadList"
                    :key='index'
                    :show-overflow-tooltip="true"
                    align="center"
                    :prop="`data_${item.sort}`"
                    :label="item.itemName"
                    width="120"
                > </el-table-column>
            </el-table>
        </div>
        <el-drawer
            title="报表自定义管理"
            :visible.sync="isShow"
            direction="rtl"
            size="70%"
            :before-close="closeIsShow">
            <StatementManipulate ref='statementManipulate'></StatementManipulate>
        </el-drawer>
    </div>
</template>
<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import StatementManipulate from '@/components/report/StatementManipulate.vue';
export default {
    components: {
        Edit24Regular,
        StatementManipulate,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    data(){
        return{
            isSearch: false, // 搜索
            reportIdList: [],
            queryForm: {
                reportId: '', // 列表id
                time: '', // 查询日期
            },
            dataList: [],
            dataHeadList: [],
            reportName: '',
            isShow: false,
        }
    },
    created() {
        this.getReportIdList();
    },
    methods:{
        // 请求数据
        getDailyData(){
            if(this.queryForm.reportId == ''){
                this.$message({
                    message: '报表选择不能为空',
                    type: 'warning',
                    duration: 2000
                });
                return
            }
            if(this.queryForm.time == null){
                this.queryForm.time = []
            }
            this.dataList = [];
            this.dataHeadList = [];
            this.reportName = ''
            get('/report/reporttable/getDailyData',{
                id: this.queryForm.reportId,
                startDate: this.queryForm.time[0],
                endDate: this.queryForm.time[1],
            }).then((res)=>{
                if(res.success){
                    this.dataList = res.list;
                    this.dataHeadList = res.report.itemList;
                    this.reportName = res.report.reportName
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },

        // 搜索
        search(){
            this.isSearch = !this.isSearch
        },

        openIsShow(){
            this.isShow = true
            this.$nextTick(()=>{
                this.$refs.statementManipulate.init()
            })
        },

        closeIsShow(){
            this.isShow = false
            this.refreshReportDailyList();
        },

        // 刷新
        refreshReportDailyList(){
            this.dataList = [];
            this.dataHeadList = [];
            this.reportName = '';
            this.getDailyData();
        },

        // 查询
        getReportDailyList(){
            this.getDailyData();
        },

        // 重置
        resetDialog(){
            this.queryForm = {
                reportId: '', // 列表id
                time: '', // 查询日期
            }
            this.dataList = [];
            this.dataHeadList = [];
            this.reportName = ''
        },

        // 获取列表id
        getReportIdList(){
            get('/report/reporttable/findAll').then((res)=>{
                if(res.success && res.code == 200){
                    this.reportIdList = res.list
                    this.queryForm.reportId = res.list[0].id
                    this.getDailyData();
                }
            })
        },
    }
}
</script>
<style lang='scss' scoped>
.title{
    font-size: 20px;
    font-weight: 700;
    margin-left: 10px;
}

.page-content{
    height: 100%;
}

</style>
